exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss"), undefined);

// module
exports.push([module.id, ".QuickLogin__quickLoginWrapper___2uJAt {\n\tbackground-color: " + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "!important;\n\t/* Only use min-height, otherwise it breaks the desktop in lower resolutions */\n\tmin-height: 100vh!important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.QuickLogin__spinnerWrapper___2Gd-d {\n\tflex: 1;\n    display: flex;\n    align-items: center;\n}\n\n.QuickLogin__spinner___2n3N4 {\n\theight: 1.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"mainTextColour": "" + require("-!../node_modules/css-loader/index.js?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./colours.icss").locals["mainTextColour"] + "",
	"quickLoginWrapper": "QuickLogin__quickLoginWrapper___2uJAt",
	"spinnerWrapper": "QuickLogin__spinnerWrapper___2Gd-d",
	"spinner": "QuickLogin__spinner___2n3N4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/QuickLogin.icss
// module id = 1604
// module chunks = 0